import Reveal from "@/components/site/Reveal";
import { IMAGES } from "@/lib/content";
import { Link } from "react-router-dom";

export default function About() {
    return (
        <section
            data-testid="about-section"
            className="bg-[#0a0a0a] text-white px-6 sm:px-10 lg:px-16 py-32 lg:py-40"
        >
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                <div className="lg:col-span-5 lg:sticky lg:top-32">
                    <Reveal>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-8">
                            01 · The House
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[0.95] tracking-tight">
                            A quiet room
                            <br />
                            for <em className="font-normal">patient</em> work.
                        </h2>
                    </Reveal>
                </div>

                <div className="lg:col-span-7 lg:pl-8 space-y-8">
                    <Reveal delay={0.15}>
                        <p className="text-lg lg:text-xl text-white/75 font-light leading-relaxed">
                            For more than three decades, Hoofs and Hides has kept its doors open
                            on Wheeler Road — not as a showroom, but as a workshop. A
                            place where hides are chosen by hand, patterns drawn on
                            paper, and stitches pulled one at a time until the seam
                            lies just so.
                        </p>
                    </Reveal>

                    <Reveal delay={0.25}>
                        <p className="text-base text-white/60 font-light leading-relaxed">
                            We don't chase seasons. We don't discount. A customer
                            from 1998 still walks in for resoles. A son returns for
                            the jacket his father wore. We prefer it that way — slow,
                            honest, and built to be inherited.
                        </p>
                    </Reveal>

                    <Reveal delay={0.35}>
                        <div className="pt-6 flex items-center gap-10">
                            <div>
                                <p className="font-serif text-5xl lg:text-6xl font-medium">
                                    34
                                </p>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mt-2">
                                    Years of the craft
                                </p>
                            </div>
                            <div className="w-px h-16 bg-white/15" />
                            <div>
                                <p className="font-serif text-5xl lg:text-6xl font-medium">
                                    ∞
                                </p>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mt-2">
                                    Repairs, forever
                                </p>
                            </div>
                        </div>
                    </Reveal>

                    <Reveal delay={0.45}>
                        <Link
                            to="/about"
                            data-testid="about-read-more"
                            className="group inline-flex items-center gap-4 mt-8 text-[11px] uppercase tracking-[0.28em] text-white hover-underline"
                        >
                            Read our story
                            <span className="w-8 h-px bg-current transition-all duration-500 group-hover:w-14" />
                        </Link>
                    </Reveal>

                    <Reveal delay={0.2} y={60} className="pt-10">
                        <div className="relative aspect-[4/5] w-full overflow-hidden">
                            <img
                                src="brand/HnH_HomePage.jpeg"
                                alt="Inside the atelier"
                                className="w-full h-full object-cover grayscale"
                            />
                            <div className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-white/80 font-mono-custom">
                                The atelier · Frazer Town
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
